import { jsx as _jsx } from "react/jsx-runtime";
import { MenuItem, Skeleton, Tooltip } from '@/core/ui';
import { useAppDispatch, useAppLocalStorage } from '@/warehouse/hooks';
import { PreventForwardRefBox, RootBox, SelectStyled } from './ActiveCrossDockSelect.styled';
import { t } from '@/core/localization';
import { defaultCrossdockingId } from '@/shared/constants';
import { useLayoutStore } from '@/shared/modules/layout/business';
import { baseApi } from '@/warehouse/baseApi';
import { stocksApi } from '@/warehouse/modules/stocks/business';
import { crossdockingHubSignalrConnector } from '@/warehouse/signalR/crossdockingHubSignalrConnector';
import { useNavigate } from 'react-router-dom';
const ActiveCrossDockSelect = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const sidebarCollapsed = useLayoutStore((state) => state.sidebarCollapsed);
    const [crossDockId, storeCrossdockId] = useAppLocalStorage({ key: 'crossDockId', initialValue: defaultCrossdockingId });
    const { data: items, isFetching } = stocksApi.endpoints.getCrossdockLookup.useQuery();
    const handleChange = (event) => {
        storeCrossdockId(event.target.value);
        // TODO: to delete later (old approach with different apis)
        // // Here should be added all the api that use `getCrossdockingId` function. Otherwise, return on any previous page can show redundant data,
        // // that was bound to old stale crossdockingId.
        // dispatch(receiptApi.util.resetApiState());
        // dispatch(packingApi.util.resetApiState());
        // dispatch(shippingApi.util.resetApiState());
        // Now, when all apis are the same base api, the following approach should be used:
        //
        // dispatch(productApiService.util.invalidateTags(["getProductsTag"]));
        // dispatch(userApiService.util.invalidateTags(["getUserOrdersTag"]));
        //
        // or try updateQueryData
        //
        // dispatch(productApiService.util.updateQueryData("getProducts", undefined, () => []));
        // dispatch(userApiService.util.updateQueryData("getUserOrders", undefined, () => []));
        dispatch(baseApi.util.resetApiState());
        // DO NOT MOVE to render space.
        // The connector is a lazily created singleton: its constructor opens the socket and dispatches to the store.
        // Resolving it here, inside the event handler, keeps those side effects out of the render phase —
        // calling it in the component body would dispatch to the store while React is rendering.
        // Moving this call here has fixed the following bug: https://global-parts.atlassian.net/browse/GPI-605
        crossdockingHubSignalrConnector().reconnect();
        // Replace is necessary since user should not be able to move back to a previous crossdocking UTD after he had
        // selected a new crossdocking.
        navigate('/', { replace: true });
    };
    if (isFetching)
        return (_jsx(RootBox, { children: _jsx(Skeleton, { height: "inputSmall" }) }));
    if (!items?.length)
        return (_jsx(RootBox, { children: _jsx(SelectStyled, { size: "small", disabled: true, value: 1, hideText: sidebarCollapsed, children: _jsx(MenuItem, { value: 1, children: sidebarCollapsed ? '' : t('empty.label') }, 1) }) }));
    return (_jsx(RootBox, { children: _jsx(Tooltip, { arrow: true, disableHoverListener: !sidebarCollapsed, title: items.find((item) => item.id === crossDockId)?.name ?? t('empty.label'), placement: "right", enterDelay: 0, leaveDelay: 0, children: _jsx(PreventForwardRefBox, { children: _jsx(SelectStyled, { size: "small", value: crossDockId, hideText: sidebarCollapsed, onChange: handleChange, children: items.map((item) => (_jsx(MenuItem, { value: item.id, children: item.name }, item.id))) }) }) }) }));
};
export { ActiveCrossDockSelect };
